import {Box, Card, CardContent, Stack, Typography} from "@mui/material";
import {EmployerCard, LongCard, PercentCard, StatusCard} from "@/modules/tickets/pages/stats/components";
import {ticketDtoStatusEnum} from "@/global/api/gen/ts/TicketDto";
import {apiTicketStats} from "@/modules/statistic/services/statistic.service";
import {TimeIcon} from "@/global/icons/TimeIcon";
import {formatDuration} from "@/global/helpers/formatters";

export function TicketStatsMain() {
    const {data} = apiTicketStats();

    return (
        <Stack
            gap={3}
            sx={{
                background: 'white',
                padding: 2,
                borderRadius: '20px',
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        lg: 'repeat(6, minmax(0, 1fr))',
                        sm: 'repeat(3, minmax(0, 1fr))',
                        xs: 'repeat(2, minmax(0, 1fr))'
                    },
                    gap: 1.5
                }}
            >
                <StatusCard
                    total={5}
                    count={data?.countNew ?? 0}
                    status={ticketDtoStatusEnum["1"]}
                />
                <StatusCard
                    total={5}
                    count={data?.pendingAdminCount ?? 0}
                    status={ticketDtoStatusEnum["2"]}
                />
                <StatusCard
                    total={5}
                    count={data?.pendingClientCount ?? 0}
                    status={ticketDtoStatusEnum["3"]}
                />
                <StatusCard
                    total={5}
                    count={data?.directGroupCount ?? 0}
                    status={ticketDtoStatusEnum["30"]}
                />
                <StatusCard
                    total={5}
                    count={data?.closedCount ?? 0}
                    status={ticketDtoStatusEnum["10"]}
                />
                <StatusCard
                    total={5}
                    count={data?.rejectCount ?? 0}
                    status={ticketDtoStatusEnum["20"]}
                />
            </Box>
            <Stack
                width={'100%'}
                flexDirection={{lg: 'row', xs: 'column'}}
                gap={3}
            >
                <Stack
                    gap={2}
                    width={{lg: '75%', xs: 'auto'}}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            overflow: 'auto',
                            gap: 1,
                            scrollSnapType: 'x mandatory'
                        }}
                    >
                        {data?.managers.map((manager, index) => (
                            <EmployerCard
                                key={index}
                                managerStats={manager}
                            />
                        ))}
                        {
                            !data || data?.managers.length === 0 && (
                                <Box minHeight={'200px'}>
                                    <Typography variant={'h5'}>
                                        Пока нет статистики по менеджерам
                                    </Typography>
                                </Box>
                            )
                        }
                    </Box>
                    <Stack
                        flexDirection={'row'}
                        gap={1}
                        flexWrap={{md: 'nowrap', xs: 'wrap'}}
                        flexGrow={1}
                        justifyContent={'space-between'}
                    >
                        <PercentCard
                            label={'Корректировка данных'}
                            percent={data?.archivePercent ?? 0}
                        />
                        <PercentCard
                            label={'Технические проблемы'}
                            percent={data?.technicalPercent ?? 0}
                        />
                        <PercentCard
                            label={'Проблемы с обучением'}
                            percent={data?.studyPercent ?? 0}
                        />
                        <PercentCard
                            label={'Прочее'}
                            percent={data?.otherPercent ?? 0}
                        />
                    </Stack>
                </Stack>
                <Stack
                    justifyContent={'space-between'}
                    gap={1}
                    width={{lg: '25%', xs: 'auto'}}
                >
                    <Card
                        sx={{
                            width: "100%",
                            background: '#F4F7FE',
                            borderRadius: '20px'
                        }}
                    >
                        <CardContent>
                            <Stack
                                flexDirection={'row'}
                                alignItems={'center'}
                                justifyContent={'space-between'}
                                gap={2}
                            >
                                <Stack
                                    alignItems={'center'}
                                    gap={1}
                                >
                                    <Typography>
                                        Средняя длительность обработки одного обращения от стадии подачи до стадии
                                        закрытия/отклонения
                                    </Typography>
                                    <Stack
                                        direction={'row'}
                                        width={'100%'}
                                        justifyContent={'space-between'}
                                    >
                                        <Typography
                                            fontSize={'18px'}
                                            fontWeight={'bold'}
                                        >
                                            {data?.averageClosedTime ? formatDuration(data.averageClosedTime) : ''}
                                        </Typography>
                                        <Box
                                            sx={{
                                                overflow: 'hidden',
                                                height: '40px'
                                            }}
                                        >
                                            <TimeIcon/>
                                        </Box>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                    <LongCard
                        label={'Процент закрытий обращений'}
                        percent={data?.closedPercent ?? 0}
                    />
                    <LongCard
                        label={'Процент отклонений обращений'}
                        percent={data?.rejectedPercent ?? 0}
                    />
                </Stack>
            </Stack>
        </Stack>
    );
}